const GetOld = (props: { path: string; }) => <iframe style={{ width: '100%', height: '100%', border: 'none' }} src={`${props.path}?v=${new Date().toLocaleDateString()}`}></iframe>;
export default GetOld;